import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';
setAutoFreeze(false); // 禁止凍結
export const customRequestSlice = createSlice({
  name: 'customRequest',
  initialState: {
    reqData: {
      order_id: '', // 訂單編號
    },
    resData: [],
  },
  reducers: {
    customRequestUpdate: (state, action) => {
      return action.payload;
    },
  },
});

/** 訂單資料 */
export const customRequestSelect = (state) => state.customRequest;
export const { customRequestUpdate } = customRequestSlice.actions;
export default customRequestSlice.reducer;
